/**
 * Created by JackCui on 2021/12/21
 */

/**
 * 1.处理辅助按钮点击 (buttonType === 'apaas_auxiliary')
 * 2.判断是否为业务按钮 (直接调用业务传递事件)
 * 3.自定义按钮路由
 */

import response from '../../../utils/response'
import {childVm} from '../../../utils/emitter'
import routerApi from './apis'
import { BUTTON_API_NAME, BUTTON_TYPES } from '../../constants/index'
import { cloneDeep } from 'lodash'

// 按钮逻辑为SAAS PAAS配置的标志
const EXECUTE_LOGIC_PAAS = 1
// const EXECUTE_LOGIC_SAAS = 2
// 0: 不控权api 1:控权api
const CONTROL_AUTH = 1
const CONTROL_NO_AUTH = 0
const routerApiMap = {
  [CONTROL_NO_AUTH]: routerApi.noAuthRouteLayout,
  [CONTROL_AUTH]: routerApi.routeLayout
}
// 按钮的操作对象的路由地址
const routerPathMap = {
  // 新增
  'apaas_create': {
    url: '/paas/edit',
    exclude: ['id', 'aPaaS_SequenceId'],
    componentName: 'edit'
  },
  // 供应商端新增
  'apaas_sur_create': {
    url: '/paas/edit',
    exclude: ['id', 'aPaaS_SequenceId'],
    componentName: 'edit'
  },
  // 商城端新增
  'apaas_mall_create': {
    url: '/paas/edit',
    exclude: ['id', 'aPaaS_SequenceId'],
    componentName: 'edit'
  },
  // 编辑
  'apaas_update': {
    url: '/paas/edit',
    exclude: [],
    componentName: 'edit'
  },
  // 供应商端编辑
  'apaas_sur_update': {
    url: '/paas/edit',
    exclude: [],
    componentName: 'edit'
  },
  // 商城端编辑
  'apaas_mall_update': {
    url: '/paas/edit',
    exclude: [],
    componentName: 'edit'
  },
  // 详情
  'apaas_detail': {
    url: '/paas/detail',
    exclude: [],
    componentName: 'detail'
  },
  // 供应商端详情
  'apaas_sur_detail': {
    url: '/paas/detail',
    exclude: [],
    componentName: 'detail'
  },
  // 商城端详情
  'apaas_mall_detail': {
    url: '/paas/detail',
    exclude: [],
    componentName: 'detail'
  }
}

/**
 * 排除对应类型按钮的无用参数
 * @param param
 * @param buttonType
 */
const excludeParams = (param, buttonType) => {
  // 排除掉exclude中的参数
  const excludeQuery = routerPathMap[buttonType] && routerPathMap[buttonType].exclude
  excludeQuery && excludeQuery.forEach(v => {
    param && delete param[v]
  })
}

/**
 * 获取按钮路由的接口
 * @param api 获取布局的接口
 * @param params
 * @returns {Promise<*>}
 */
export const fetchRouterLayout = async ({type, url}, params) => {
  const {objectApiName, tenantType, operationApiName} = params
  return response({
    method: type,
    url,
    params,
    headerParams: {
      'APAAS-OBJECT-API-NAME': objectApiName,
      'APAAS-OPERATION-API-NAME': operationApiName,
      'APAAS-TENANT-TYPE': tenantType
    },
    option: {
      loadingOptions: true
    }
  })
}

/**
 * 覆盖url参数
 * @param url
 * @param row
 * @returns {*}
 */
function transferUrl (url, row) {
  // 匹配url中'${xxx}'
  const regExp = /\${.+?}/
  const apiNameExp = /\${(\S*)}/
  const handle = () => {
    const apiName = url.match(regExp)?.[0]
    if (apiName) {
      const key = apiName.match(apiNameExp)?.[1]
      url = url.replace(regExp, row[key] || '')
      handle()
    }
  }
  handle()
  return url
}

/**
 * 拼接path
 * @param params
 * @param routeLayout
 * @returns {{path: (*|string), query: *}}
 */
const routerPathHandle = (params, routeLayout) => {
  const {
    url,
    query = {},
    buttonItem = {},
    linkObjectModel: {operationApiName: operation} = {}
  } = params
  const {buttonType, permissionPointApiName} = buttonItem
  const operationApiName = operation || permissionPointApiName
  const {
    detail: {frontUrl},
    objectApiName,
    elementApiName: layoutApiName
  } = routeLayout
  const {linkObjectModel: {tenantType}} = params
  const uri = frontUrl ||
    `${
      routerPathMap[buttonType]
        ? routerPathMap[buttonType]['url']
        : url
    }/${tenantType}/${objectApiName}/${layoutApiName}/${operationApiName}`
  const param = {
    objectApiName,
    layoutApiName,
    tenantType,
    operationApiName,
    ...query
  }
  // 排除掉exclude中的参数
  excludeParams(param, buttonType)
  return {
    // todo 等待联调
    path: uri,
    query: param
  }
}

/**
 * 打开弹窗页面函数
 * @param _this
 * @param buttonItem
 * @param linkObjectModel
 * @param row
 * @param flag 弹窗开启关闭
 */
function toggleWindowHandle (_this, {buttonItem, linkObjectModel, row}, flag) {
  const popupBoxVm = childVm.call(_this, 'popup-window')
  if (Array.isArray(popupBoxVm) && !popupBoxVm.length) {
    return
  }
  // 关闭弹窗
  if (!flag) {
    return popupBoxVm['close']()
  }
  const params = cloneDeep(row)
  excludeParams(params, buttonItem.buttonType)
  // 打开弹窗
  popupBoxVm['openWindow'](buttonItem, linkObjectModel, params)
}

/**
 * 按钮事件根据不同type处理路由跳转
 * @param params
 * @param routeLayout
 */
const buttonEventTypeHandle = (params, routeLayout) => {
  const _this = window.vueInstantiation
  const {detail} = routeLayout
  const {pageType, openType, url} = detail || {pageType: 'page', openType: 'current'}
  const eventTypeHandleMap = {
    'page': {
      'new': (params, routeLayout) => {
        let routeUrl = _this.$router.resolve(
          routerPathHandle(params, routeLayout)
        )
        window.open(routeUrl.href, '_blank')
      },
      'current': (params, routeLayout) => {
        const {type = 'push'} = params
        _this.$router[type](
          routerPathHandle(params, routeLayout)
        )
      }
    },
    'window': {
      'window': function ({linkObjectModel, buttonItem, row}) {
        const {objectApiName, elementApiName} = routeLayout
        // const {permissionPointApiName} = buttonItem
        toggleWindowHandle(
          _this,
          {
            buttonItem,
            linkObjectModel: {
              ...linkObjectModel,
              // operationApiName: permissionPointApiName,
              objectApiName,
              layoutApiName: elementApiName,
              config: routerPathMap[linkObjectModel?.operationApiName] || {componentName: 'edit'}
            },
            row
          },
          true
        )
      }
    },
    'custom': {
      'new': ({row}) => {
        window.open(transferUrl(url, row), '_blank')
      },
      'current': ({row}) => {
        window.open(transferUrl(url, row), '_self')
      }
    }
  }
  eventTypeHandleMap[pageType][openType](params, routeLayout)
}

/**
 * 自定义按钮的事件
 * @param params
 *  url 路由路径 (router path)
 *  type 跳转类型 (push/replace)
 *  buttonItem 按钮的信息
 *  row 行的数据
 *  query 跳转页面需要携带的query
 *  linkObjectModel 外部调用一些必须参数 (objectApiName, layoutApiName, operationApiName, tenantType)
 * @returns {Promise<void>}
 */
const customButtonEvent = async (params) => {
  const {project: app, client: targetPoint = 'PC'} = window?.fe?.apaas?.biz || {}
  const {linkObjectModel, buttonItem = {}, row} = params
  const {
    apiName: buttonApiName,
    // controlAuth 0: 不控权按钮 1:控权按钮
    controlAuth
  } = buttonItem
  // 是否控权标记
  // TODO 后端会返回null...
  const authFlag = typeof controlAuth !== 'number'
    ? CONTROL_AUTH
    : controlAuth
  // 如果是行上按钮行的ID
  const sequenceId = row?.['aPaaS_SequenceId'] || ''
  // 调用路由接口
  const {content: routeLayout, isOk} = await fetchRouterLayout(
    routerApiMap[authFlag],
    {
      ...linkObjectModel,
      sequenceId,
      buttonApiName,
      app,
      targetPoint
    }
  )
  if (!routeLayout) {
    return console.log(new Error('按钮参数无效'))
  }

  if (isOk) {
    buttonEventTypeHandle(params, routeLayout)
  }
}

/**
 * 按钮点击逻辑
 * @param params
 *  url 路由路径 (router path)
 *  type 跳转类型 (push/replace)
 *  buttonItem 按钮的信息
 *  row 行的数据
 *  query 跳转页面需要携带的query
 *  linkObjectModel 外部调用一些必须参数 (objectApiName, layoutApiName, operationApiName, tenantType)
 * @returns {Promise<void>}
 */
export const clickEventHandler = async (params) => {
  const {buttonItem = {}} = params
  const {
    // executeLogic 1:PaaS按钮 2:SaaS按钮 (SaaS按钮不请求路由接口)
    executeLogic,
    event: {beforeClickHandle, click} = {}
  } = buttonItem

  let res

  // 点击前的时间回调
  if (beforeClickHandle) {
    try {
      res = await new Promise((resolve, reject) => {
        beforeClickHandle({...params, resolve, reject})
      })
    } catch (e) {
      return
    }
  }
  
  // 按钮单击事件
  if (click) {
    return click(params, res)
  }

  // 处理自定义按钮 路由事件
  if (!executeLogic || executeLogic === EXECUTE_LOGIC_PAAS) {
    await customButtonEvent(params)
  }
}

export function createdEvent (eventNames = []) {
  const events = {
    [BUTTON_API_NAME.BUTTON_DELETE]: {
      event: {
        click: ({buttonItem, row}) => {
          this.removeLine(buttonItem, row)
        }
      }
    },
    [BUTTON_API_NAME.BUTTON_CREATE]: {
      event: {
        click: ({buttonItem}) => {
          this.addLine(buttonItem)
        }
      }
    },
    [BUTTON_API_NAME.BUTTON_SUBMIT]: {
      event: {
        click: async ({buttonItem}) => {
          const res = await this.handleSubmit()
          buttonItem.event?.submit && buttonItem.event.submit(res)
        }
      }
    },
    [BUTTON_API_NAME.BUTTON_BATCH_DELETE]: {
      event: {
        click: ({buttonItem}) => {
          this.handleBatchRemove(buttonItem)
        }
      }
    },
    [BUTTON_TYPES.IMPORT]: {
      event: {
        click: ({buttonItem}) => {
          this.handleImport(buttonItem)
        }
      }
    },
    [BUTTON_TYPES.EXPORT]: {
      event: {
        click: ({buttonItem}) => {
          this.handleExport(buttonItem)
        }
      }
    },
    [BUTTON_TYPES.PRINT]: {
      event: {
        click: async (params) => {
          const {project: app, client: targetPoint = 'PC'} = window?.fe?.apaas?.biz || {}
          const {linkObjectModel, buttonItem = {}} = params
          const {
            apiName: buttonApiName,
            // controlAuth 0: 不控权按钮 1:控权按钮
            controlAuth
          } = buttonItem
          // 是否控权标记
          // TODO 后端会返回null...
          const authFlag = typeof controlAuth !== 'number'
            ? CONTROL_AUTH
            : controlAuth
          // 调用路由接口
          const {content, isOk} = await fetchRouterLayout(
            routerApiMap[authFlag],
            {
              ...linkObjectModel,
              sequenceId: '',
              buttonApiName,
              app,
              targetPoint
            }
          )
          if (isOk) {
            this.handlePrint(content, linkObjectModel)
          }
        }
      }
    }
  }
  if (eventNames.length === 0) {
    return events
  }
  const _event = {}
  eventNames.forEach(key => {
    if (events[key]) {
      _event[key] = events[key]
    }
  })
  return _event
}
